import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { media } from 'src/styles/styled-components'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import ArBaseImage from 'src/components/ArBaseImage/ArBaseImage'

const StyledWrapper = styled.section`
  background-color: ${ ({ theme }) => theme.colors.black } ;
  color: ${ ({ theme }) => theme.colors.white } ;
  padding-bottom: 40px;
  padding-top: 54px;

  ${ media.tablet`
    padding-top: 80px;
    padding-bottom: 80px;
  ` }

  ${ media.desktop`
    padding-top: 120px;
    padding-bottom: 125px;
  ` }
`

const StyledContainer = styled(ArBaseContainer)`

  ${ media.desktop`
    display: flex;
    justify-content: space-between;
  ` }
`

const StyledColumn = styled.div`

  & + & {
    margin-top: 50px;
  }

  ${ media.tablet`
    display: flex;
    flex-direction: ${ p => !p.stSecondCol && 'row-reverse' };

    & + & {
      margin-top: 72px;
    }
  ` }

  ${ media.desktop`
    display: block;
    width: ${ p => !p.stSecondCol ? '43.9516129%' : '41.0483871%' };

    & + & {
      margin-top: 0;
    }

  ` }
`

const StyledImage = styled(ArBaseImage)`
  margin-bottom: ${ p => !p.stSecondCol ? '21px' : '51px' };
  max-width: 400px;
  padding: ${ p => !p.stSecondCol && '0 5px' };
  margin-left: auto;
  margin-right: auto;

  img {
    height: auto;
  }

  ${ media.tablet`
    width: 58.2%;
    padding: 0;
    margin: 0;
    flex-shrink: 0;
    margin-right: ${ p => !p.stSecondCol ? '-3px' : '11px' };
    margin-left: ${ p => p.stSecondCol ? '-43px' : '14px' };
  ` }

  ${ media.desktop`
    margin-right: 0;
    width: 100%;
    margin-left: ${ p => !p.stSecondCol ? '10px' : '5px' };
  ` }
`

const StyledTitle = styled.h2`
  font-size: 2.8rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
  line-height: 1.2;
  margin-bottom: 20px;
  text-align: center;

  ${ media.tablet`
    text-align: left;
    font-size: 4.5rem;
    margin-bottom: 30px;
    text-align: left;
  ` }

  ${ media.desktop`
    min-height: 108px;
    display: flex;
    align-items: flex-start;
    max-width: ${ p => !p.stSecondCol && '445px' };
  ` }
`

const StyledDescription = styled.p`
  font-size: 1.8rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
  letter-spacing: 0.01em;
  line-height: 1.55;
  text-align: center;

  ${ media.tablet`
    text-align: left;
  ` }
`

class ArDocumentColumns extends React.Component {
  static propTypes = {
    columns: PropTypes.array,
  }

  render () {
    const { columns } = this.props

    return (
      <StyledWrapper>
        <StyledContainer>
          {columns.map(({ image, title, description }, index) =>
            <StyledColumn key={index} stSecondCol={!!index}>
              <StyledImage src={image.url} stSecondCol={!!index}></StyledImage>
              <div>
                <StyledTitle stSecondCol={!!index}>{ title }</StyledTitle>
                <StyledDescription>{ description }</StyledDescription>
              </div>
            </StyledColumn>
          )}
        </StyledContainer>
      </StyledWrapper>
    )
  }
}

export default ArDocumentColumns
